import { render, staticRenderFns } from "./resetPassword.vue?vue&type=template&id=22a5d60e&scoped=true"
import script from "./resetPassword.ts?vue&type=script&lang=js&external"
export * from "./resetPassword.ts?vue&type=script&lang=js&external"
import style0 from "./resetPassword.css?vue&type=style&index=0&id=22a5d60e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a5d60e",
  null
  
)

export default component.exports